/**
 * Global configuration for the polling client.
 */
export const POLLING_CONFIG = {
  MAX_WAIT_MS: 2 * 60 * 1000, // 2 minutes
  BASE_DELAY_MS: 1000, // 1 second
  MAX_DELAY_MS: 15_000, // 15 seconds
} as const;

/**
 * Centralized HTTP status constants
 * Used across all services for consistency
 */
export const HTTP_STATUS = {
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR_MIN: 500,
  INTERNAL_SERVER_ERROR_MAX: 599,
} as const;
